import { useTranslation } from 'react-i18next';
import bannerLayer from '@/assets/imgs/news/banner-layer.png';
import banner from '@/assets/imgs/news/banner.png';

export function NewsHero() {
  const { t } = useTranslation();

  return (
    <section className="h-[530px] bg-white pt-[30px]">
      <div
        className="relative mx-auto h-[500px] w-[1800px] overflow-hidden rounded-[30px] bg-top bg-no-repeat bg-[length:100%_auto]"
        style={{ backgroundImage: `url(${bannerLayer})` }}
      >
        <img src={banner} alt="" className="absolute inset-0 size-full object-cover" />
        <div className="absolute inset-0 bg-black/20 mix-blend-hard-light" />
        <h1 className="font-douyin relative z-10 flex size-full items-center justify-center text-[70px] font-bold leading-[1.5] text-white">
          {t('news.list.title')}
        </h1>
      </div>
    </section>
  );
}
